<div class="dataset-detail-home flex flex-col min-h-screen bg-[var(--consumer-canvas-bg)]">
  <app-header [forceLightBackground]="true"></app-header>

  <main class="dataset-detail-home__main flex-1 w-full pt-20">
    <div class="dataset-detail-home__container mx-auto w-full px-4 pb-10">
      @if (loading()) {
        <div class="dataset-detail-home__skeleton flex flex-col gap-6 py-4">
          <app-skeleton variant="detail-header" />
          <app-skeleton variant="detail-body" />
        </div>
      } @else {
        <app-detail-header
          [config]="headerConfig"
          [showAssetActions]="true"
          [isLoggedIn]="isLoggedIn()"
          [isBookmarked]="isBookmarked()"
          [isLiked]="isLiked()"
          (bookmarkClick)="onHeaderBookmarkClick()"
          (likeClick)="onHeaderLikeClick()"
          (loginRequired)="showLoginModal.set(true)"
        ></app-detail-header>

        <div id="dataset-detail-tabs" class="dataset-detail-home__tabs-row mt-6">
          <div class="dataset-detail-home__tabs flex flex-wrap gap-2">
            <button
              type="button"
              class="dataset-detail-home__tab"
              [class.dataset-detail-home__tab--active]="activeTab() === 'dataset'"
              (click)="onTabClick('dataset')"
            >
              Datasets
            </button>
            <button
              type="button"
              class="dataset-detail-home__tab"
              [class.dataset-detail-home__tab--active]="activeTab() === 'details'"
              (click)="onTabClick('details')"
            >
              @if (!isLoggedIn()) {
                <img
                  class="dataset-detail-home__tab-lock"
                  [src]="activeTab() === 'details' ? '/icons/tab-lock-dark.svg' : '/icons/tab-lock.svg'"
                  width="16"
                  height="16"
                  alt=""
                />
              }
              Details
            </button>
            <button
              type="button"
              class="dataset-detail-home__tab"
              [class.dataset-detail-home__tab--active]="activeTab() === 'visualisation'"
              (click)="onTabClick('visualisation')"
            >
              @if (!isLoggedIn()) {
                <img
                  class="dataset-detail-home__tab-lock"
                  [src]="activeTab() === 'visualisation' ? '/icons/tab-lock-dark.svg' : '/icons/tab-lock.svg'"
                  width="16"
                  height="16"
                  alt=""
                />
              }
              Visualisation
            </button>
            <button
              type="button"
              class="dataset-detail-home__tab"
              [class.dataset-detail-home__tab--active]="activeTab() === 'sql-playground'"
              (click)="onTabClick('sql-playground')"
            >
              @if (!isLoggedIn()) {
                <img
                  class="dataset-detail-home__tab-lock"
                  [src]="activeTab() === 'sql-playground' ? '/icons/tab-lock-dark.svg' : '/icons/tab-lock.svg'"
                  width="16"
                  height="16"
                  alt=""
                />
              }
              SQL Playground
            </button>
          </div>
        </div>

        <div class="mt-6">
          @switch (activeTab()) {
            @case ('dataset') {
              @if (datasetId) {
                <app-dataset-detail-dataset-tab
                  [datasetId]="datasetId"
                  [detailRows]="detailRows()"
                  [datasetDescription]="datasetDescription"
                  [datasetTags]="datasetTags"
                  [activityMetrics]="activityMetrics"
                  [sampleData]="sampleData"
                  [isLoggedIn]="isLoggedIn()"
                  [viewCodeText]="viewCodeText"
                  [getDataSnippet]="getDataSnippet"
                  [resourceServersList]="resourceServersList"
                  [fullDatasetPayload]="fullDatasetPayload"
                  (authRefreshRequested)="onDatasetTabAuthRefresh()"
                />
              }
            }
            @case ('details') {
              <app-dataset-detail-details-tab
                [datasetId]="datasetId"
                [license]="detailRows()['license']"
              />
            }
            @case ('visualisation') {
              <app-dataset-detail-visualisation-tab
                [datasetId]="datasetId"
                [license]="detailRows()['license']"
              />
            }
            @case ('sql-playground') {
              <app-dataset-detail-sql-playground-tab
                [datasetId]="datasetId"
                [license]="detailRows()['license']"
              />
            }
          }
        </div>
      }
    </div>
  </main>

  <app-footer></app-footer>

  @if (showLoginModal()) {
    <app-login-modal (visibleChange)="onLoginModalClose()"></app-login-modal>
  }
</div>
